export type IconsId =
  | 'youtube'
  | 'x'
  | 'wishlist'
  | 'wishlist-thin'
  | 'wishlist-fill'
  | 'up'
  | 'unmute'
  | 'twitter'
  | 'trash'
  | 'tiktok'
  | 'tick'
  | 'thick'
  | 'stores'
  | 'star'
  | 'star-half'
  | 'star-fill'
  | 'star-empty'
  | 'size-guide'
  | 'simple-search'
  | 'shop'
  | 'share'
  | 'secure-lock'
  | 'search'
  | 'right'
  | 'quote'
  | 'question'
  | 'plus'
  | 'plus-thin'
  | 'plus-24'
  | 'play'
  | 'pinterest'
  | 'phone'
  | 'percent'
  | 'pause'
  | 'ok'
  | 'no-shows'
  | 'mute'
  | 'minus'
  | 'menu'
  | 'media-grid'
  | 'media-carousel'
  | 'manifest'
  | 'login'
  | 'locator'
  | 'location'
  | 'location-fill'
  | 'location-arrow'
  | 'left'
  | 'instagram'
  | 'informations'
  | 'information'
  | 'info'
  | 'heart-right-fill'
  | 'heart-left-fill'
  | 'gift'
  | 'gift-24'
  | 'filter'
  | 'facebook'
  | 'empty-search'
  | 'email'
  | 'email-24'
  | 'down'
  | 'delivery'
  | 'cookies'
  | 'contact'
  | 'coin'
  | 'close'
  | 'close-thin'
  | 'close-circle'
  | 'close-24'
  | 'click-and-collect'
  | 'chevron-up'
  | 'chevron-up-24'
  | 'chevron-right'
  | 'chevron-right-24'
  | 'chevron-left'
  | 'chevron-left-24'
  | 'chevron-down'
  | 'chevron-down-smal'
  | 'chevron-down-24'
  | 'chat'
  | 'cards'
  | 'card'
  | 'cancel'
  | 'booking-in'
  | 'basket'
  | 'arrow-up'
  | 'arrow-right'
  | 'arrow-left'
  | 'arrow-forward'
  | 'add-account'
  | 'account'
  | 'account-header'
  | '5-columns'
  | '3-columns'
  | '2-columns'
  | '1-columns';

export type IconsKey =
  | 'Youtube'
  | 'X'
  | 'Wishlist'
  | 'WishlistThin'
  | 'WishlistFill'
  | 'Up'
  | 'Unmute'
  | 'Twitter'
  | 'Trash'
  | 'Tiktok'
  | 'Tick'
  | 'Thick'
  | 'Stores'
  | 'Star'
  | 'StarHalf'
  | 'StarFill'
  | 'StarEmpty'
  | 'SizeGuide'
  | 'SimpleSearch'
  | 'Shop'
  | 'Share'
  | 'SecureLock'
  | 'Search'
  | 'Right'
  | 'Quote'
  | 'Question'
  | 'Plus'
  | 'PlusThin'
  | 'Plus24'
  | 'Play'
  | 'Pinterest'
  | 'Phone'
  | 'Percent'
  | 'Pause'
  | 'Ok'
  | 'NoShows'
  | 'Mute'
  | 'Minus'
  | 'Menu'
  | 'MediaGrid'
  | 'MediaCarousel'
  | 'Manifest'
  | 'Login'
  | 'Locator'
  | 'Location'
  | 'LocationFill'
  | 'LocationArrow'
  | 'Left'
  | 'Instagram'
  | 'Informations'
  | 'Information'
  | 'Info'
  | 'HeartRightFill'
  | 'HeartLeftFill'
  | 'Gift'
  | 'Gift24'
  | 'Filter'
  | 'Facebook'
  | 'EmptySearch'
  | 'Email'
  | 'Email24'
  | 'Down'
  | 'Delivery'
  | 'Cookies'
  | 'Contact'
  | 'Coin'
  | 'Close'
  | 'CloseThin'
  | 'CloseCircle'
  | 'Close24'
  | 'ClickAndCollect'
  | 'ChevronUp'
  | 'ChevronUp24'
  | 'ChevronRight'
  | 'ChevronRight24'
  | 'ChevronLeft'
  | 'ChevronLeft24'
  | 'ChevronDown'
  | 'ChevronDownSmal'
  | 'ChevronDown24'
  | 'Chat'
  | 'Cards'
  | 'Card'
  | 'Cancel'
  | 'BookingIn'
  | 'Basket'
  | 'ArrowUp'
  | 'ArrowRight'
  | 'ArrowLeft'
  | 'ArrowForward'
  | 'AddAccount'
  | 'Account'
  | 'AccountHeader'
  | 'i5Columns'
  | 'i3Columns'
  | 'i2Columns'
  | 'i1Columns';

export enum Icons {
  Youtube = 'youtube',
  X = 'x',
  Wishlist = 'wishlist',
  WishlistThin = 'wishlist-thin',
  WishlistFill = 'wishlist-fill',
  Up = 'up',
  Unmute = 'unmute',
  Twitter = 'twitter',
  Trash = 'trash',
  Tiktok = 'tiktok',
  Tick = 'tick',
  Thick = 'thick',
  Stores = 'stores',
  Star = 'star',
  StarHalf = 'star-half',
  StarFill = 'star-fill',
  StarEmpty = 'star-empty',
  SizeGuide = 'size-guide',
  SimpleSearch = 'simple-search',
  Shop = 'shop',
  Share = 'share',
  SecureLock = 'secure-lock',
  Search = 'search',
  Right = 'right',
  Quote = 'quote',
  Question = 'question',
  Plus = 'plus',
  PlusThin = 'plus-thin',
  Plus24 = 'plus-24',
  Play = 'play',
  Pinterest = 'pinterest',
  Phone = 'phone',
  Percent = 'percent',
  Pause = 'pause',
  Ok = 'ok',
  NoShows = 'no-shows',
  Mute = 'mute',
  Minus = 'minus',
  Menu = 'menu',
  MediaGrid = 'media-grid',
  MediaCarousel = 'media-carousel',
  Manifest = 'manifest',
  Login = 'login',
  Locator = 'locator',
  Location = 'location',
  LocationFill = 'location-fill',
  LocationArrow = 'location-arrow',
  Left = 'left',
  Instagram = 'instagram',
  Informations = 'informations',
  Information = 'information',
  Info = 'info',
  HeartRightFill = 'heart-right-fill',
  HeartLeftFill = 'heart-left-fill',
  Gift = 'gift',
  Gift24 = 'gift-24',
  Filter = 'filter',
  Facebook = 'facebook',
  EmptySearch = 'empty-search',
  Email = 'email',
  Email24 = 'email-24',
  Down = 'down',
  Delivery = 'delivery',
  Cookies = 'cookies',
  Contact = 'contact',
  Coin = 'coin',
  Close = 'close',
  CloseThin = 'close-thin',
  CloseCircle = 'close-circle',
  Close24 = 'close-24',
  ClickAndCollect = 'click-and-collect',
  ChevronUp = 'chevron-up',
  ChevronUp24 = 'chevron-up-24',
  ChevronRight = 'chevron-right',
  ChevronRight24 = 'chevron-right-24',
  ChevronLeft = 'chevron-left',
  ChevronLeft24 = 'chevron-left-24',
  ChevronDown = 'chevron-down',
  ChevronDownSmal = 'chevron-down-smal',
  ChevronDown24 = 'chevron-down-24',
  Chat = 'chat',
  Cards = 'cards',
  Card = 'card',
  Cancel = 'cancel',
  BookingIn = 'booking-in',
  Basket = 'basket',
  ArrowUp = 'arrow-up',
  ArrowRight = 'arrow-right',
  ArrowLeft = 'arrow-left',
  ArrowForward = 'arrow-forward',
  AddAccount = 'add-account',
  Account = 'account',
  AccountHeader = 'account-header',
  i5Columns = '5-columns',
  i3Columns = '3-columns',
  i2Columns = '2-columns',
  i1Columns = '1-columns',
}

export const ICONS_CODEPOINTS: { [key in Icons]: string } = {
  [Icons.Youtube]: '61697',
  [Icons.X]: '61698',
  [Icons.Wishlist]: '61699',
  [Icons.WishlistThin]: '61700',
  [Icons.WishlistFill]: '61701',
  [Icons.Up]: '61702',
  [Icons.Unmute]: '61703',
  [Icons.Twitter]: '61704',
  [Icons.Trash]: '61705',
  [Icons.Tiktok]: '61706',
  [Icons.Tick]: '61707',
  [Icons.Thick]: '61708',
  [Icons.Stores]: '61709',
  [Icons.Star]: '61710',
  [Icons.StarHalf]: '61711',
  [Icons.StarFill]: '61712',
  [Icons.StarEmpty]: '61713',
  [Icons.SizeGuide]: '61714',
  [Icons.SimpleSearch]: '61715',
  [Icons.Shop]: '61716',
  [Icons.Share]: '61717',
  [Icons.SecureLock]: '61718',
  [Icons.Search]: '61719',
  [Icons.Right]: '61720',
  [Icons.Quote]: '61721',
  [Icons.Question]: '61722',
  [Icons.Plus]: '61723',
  [Icons.PlusThin]: '61724',
  [Icons.Plus24]: '61725',
  [Icons.Play]: '61726',
  [Icons.Pinterest]: '61727',
  [Icons.Phone]: '61728',
  [Icons.Percent]: '61729',
  [Icons.Pause]: '61730',
  [Icons.Ok]: '61731',
  [Icons.NoShows]: '61732',
  [Icons.Mute]: '61733',
  [Icons.Minus]: '61734',
  [Icons.Menu]: '61735',
  [Icons.MediaGrid]: '61736',
  [Icons.MediaCarousel]: '61737',
  [Icons.Manifest]: '61738',
  [Icons.Login]: '61739',
  [Icons.Locator]: '61740',
  [Icons.Location]: '61741',
  [Icons.LocationFill]: '61742',
  [Icons.LocationArrow]: '61743',
  [Icons.Left]: '61744',
  [Icons.Instagram]: '61745',
  [Icons.Informations]: '61746',
  [Icons.Information]: '61747',
  [Icons.Info]: '61748',
  [Icons.HeartRightFill]: '61749',
  [Icons.HeartLeftFill]: '61750',
  [Icons.Gift]: '61751',
  [Icons.Gift24]: '61752',
  [Icons.Filter]: '61753',
  [Icons.Facebook]: '61754',
  [Icons.EmptySearch]: '61755',
  [Icons.Email]: '61756',
  [Icons.Email24]: '61757',
  [Icons.Down]: '61758',
  [Icons.Delivery]: '61759',
  [Icons.Cookies]: '61760',
  [Icons.Contact]: '61761',
  [Icons.Coin]: '61762',
  [Icons.Close]: '61763',
  [Icons.CloseThin]: '61764',
  [Icons.CloseCircle]: '61765',
  [Icons.Close24]: '61766',
  [Icons.ClickAndCollect]: '61767',
  [Icons.ChevronUp]: '61768',
  [Icons.ChevronUp24]: '61769',
  [Icons.ChevronRight]: '61770',
  [Icons.ChevronRight24]: '61771',
  [Icons.ChevronLeft]: '61772',
  [Icons.ChevronLeft24]: '61773',
  [Icons.ChevronDown]: '61774',
  [Icons.ChevronDownSmal]: '61775',
  [Icons.ChevronDown24]: '61776',
  [Icons.Chat]: '61777',
  [Icons.Cards]: '61778',
  [Icons.Card]: '61779',
  [Icons.Cancel]: '61780',
  [Icons.BookingIn]: '61781',
  [Icons.Basket]: '61782',
  [Icons.ArrowUp]: '61783',
  [Icons.ArrowRight]: '61784',
  [Icons.ArrowLeft]: '61785',
  [Icons.ArrowForward]: '61786',
  [Icons.AddAccount]: '61787',
  [Icons.Account]: '61788',
  [Icons.AccountHeader]: '61789',
  [Icons.i5Columns]: '61790',
  [Icons.i3Columns]: '61791',
  [Icons.i2Columns]: '61792',
  [Icons.i1Columns]: '61793',
};
